import { render, staticRenderFns } from "./NewKnowledgePublic.vue?vue&type=template&id=547bf0de&scoped=true&"
import script from "./NewKnowledgePublic.vue?vue&type=script&lang=js&"
export * from "./NewKnowledgePublic.vue?vue&type=script&lang=js&"
import style0 from "./NewKnowledgePublic.vue?vue&type=style&index=0&id=547bf0de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547bf0de",
  null
  
)

export default component.exports